import { toast } from "react-toastify";

const isRawAuthToast = (message) => {
  const normalized = String(message || "").trim().toLowerCase();
  return (
    normalized === "unauthenticated." ||
    normalized === "unauthenticated" ||
    normalized === "unathenticated." ||
    normalized === "unathenticated"
  );
};

export const toastify = (type, toastMessage) => {
  if (!toastMessage) return;
  // Session-expiry UX is handled centrally by the request interceptor.
  if (type === "error" && isRawAuthToast(toastMessage)) return;

  switch (type) {
    case "info":
      toast.info(toastMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        textTransform: "capitalize",
      });
      break;
    case "success":
      toast.success(toastMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        textTransform: "capitalize",
      });
      break;
    case "error":
      toast.error(toastMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        textTransform: "capitalize",
      });
      break;
    case "warning":
      toast.warn(toastMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        textTransform: "capitalize",
      });
      break;

    default:
      break;
  }
};
